module.exports = __webpack_public_path__ + "media/images/iphone-3d666859.png";